import $ from "jquery"
import moment from "moment"
import {useIdleTimer} from "react-idle-timer"
import {getAdvices} from "../API/advices"
import {openpdfreport} from "../API/analysendata"
import {logoutUser} from "../API/user"
import {getAdditionalReportDetail, getReportLink} from "../API/report";
//import {getReportDetail} from "../API/report";
import {getParsedData} from "../API/analysenrequestdata";

export const getToken = () => {
    return sessionStorage.getItem("token") || null
}

export const hasToken = () => {
    if (getToken() === null) {
        localStorage.clear()
        sessionStorage.clear()
        location.href = `${process.env.REACT_APP_FRONTEND_PATH_LOGIN}`
    }
}

export const hasNoReportAccess = (x) => {
    if (x !== process.env.REACT_APP_BASE_VALID_REPORTLINK_ACCESS) {
        localStorage.clear()
        sessionStorage.clear()
        location.href = `${process.env.REACT_APP_FRONTEND_PATH_LOGIN}`
    }
}

// remove the token and user from the session storage
export const removeUserSession = () => {
    sessionStorage.removeItem("token")
}

// set the token and user from the session storage
export const setUserSession = (token) => {
    sessionStorage.setItem("token", token)
}

export const setLVstatus = (companylvstatus) => {
    sessionStorage.setItem("lv", companylvstatus)
}

export const setAPPstatus = (companyappstatus) => {
    sessionStorage.setItem("app", companyappstatus)
}

export const setRoleSession = (roles) => {

    let userroles = Object.values(roles)
    sessionStorage.setItem("roles", JSON.stringify(userroles))
}

export const setUserOrganisation = (org) => {
    sessionStorage.setItem("org", org);
};

export const getRole = () => {
    return sessionStorage.getItem("roles") || null
}

export function getOut(e) {
    //alert("Please login again")
    console.log(e);
    // location.href = `${process.env.REACT_APP_FRONTEND_PATH_LOGIN}`;
    // localStorage.clear();
    // sessionStorage.clear();
    // removeUserSession();
}

export async function ranOut() {
    let timetowait4response = 0
    if (window.location.pathname === `${process.env.REACT_APP_FRONTEND_PATH_ANNOTATORPAGE}`) {
        // Before the session goes we save the analyse and await for response
        timetowait4response = 9000
    }
    setTimeout(function () {
        logoutUser()
        getOut("logged out by session time")
    }, timetowait4response)
}

export function checksessiontime() {
    hasToken()
    const timeout = 1000 * 60 * `${process.env.REACT_APP_FRONTEND_SESSIONTIME}` //time in ms
    const handleOnIdle = () => ranOut()
    useIdleTimer({
        timeout, onIdle: handleOnIdle, crossTab: {emitOnAllTabs: true}
    })
}

export function checkPassword(password) {
    if (password !== null || password !== "") {
        document.getElementById("c1").checked = password.length > 7 && password.length < 51
        document.getElementById("c2").checked = password.toLowerCase() !== password
        document.getElementById("c3").checked = /^[a-zA-Z0-9- ]*$/.test(password) === false
        document.getElementById("c4").checked = /\d/.test(password) === true
    } else {
        console.log("ERROR: Password Validation")
    }
    // If the password is empty, the 5th animate UI dot should be red
    if (password === "") {
        document.getElementById("c5").checked = false
    }
    return (document.getElementById("c1").checked && document.getElementById("c2").checked && document.getElementById("c3").checked && document.getElementById("c3").checked && document.getElementById("c5").checked)
}

/**
 * Date :: Format and Sort
 * Function helps to format the date and be able to sort in respective table.
 */
export function dateFormatSort() {
    $.fn.dataTable.moment = function (format, locale) {
        let types = $.fn.dataTable.ext.type
        // Adds type detection
        types.detect.unshift(function (d) {
            return moment(d, format, locale, true).isValid() ? "moment-" + format : null
        })
        // Adds sorting method - using an integer for the sorting
        types.order["moment-" + format + "-pre"] = function (d) {
            return moment(d, format, locale, true).unix()
        }
    }
    $.fn.dataTable.moment("DD.MM.YYYY")
}

/**
 * Getting the pathname from the url string
 * @param href url string
 * @returns {HTMLAnchorElement} <a> element
 */
const getLocation = function (href) {
    let l = document.createElement("a");
    l.href = href;
    return l;
};

/**
 * Function redirects user to respective Web Report
 * @param history -  An Object with functions used to navigate page
 * @param obj - An Object of one analyse request json
 */
export async function showWebReport(history, obj) {

    let [lvInfo, adviceCatalogData, hinweisData, potentialData, risikoData] = ["", "", "", "", ""]
    let lvID = obj.uploadlv_id
    let reportLink = await getReportLink(lvID)

    if (reportLink.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
        getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`)
    }

    let url = reportLink.response.url
    let l = getLocation(url)

    async function getWebReportPageData() {
        lvInfo = await getParsedData(obj)
        adviceCatalogData = await getAdvices()
        //let reportData = await getReportDetail(lvID)
        let reportData = await getAdditionalReportDetail(lvID)
        //reportData = reportData.response
        hinweisData = reportData?.filter(item => item.type === 'Hinweis');
        potentialData = reportData?.filter(item => item.type === 'Potenzial');
        risikoData = reportData?.filter(item => item.type === 'Risiko');

    }

    getWebReportPageData().then(() => {
        let modifiedData = addGtext(lvInfo, hinweisData, potentialData,
            risikoData)
        history.push(l.pathname, {
            "adviceCatalogData": adviceCatalogData,
            "lvInfo": lvInfo,
            "hinweisData": modifiedData.hinweisData,
            "potentialData": modifiedData.potentialData,
            "risikoData": modifiedData.risikoData,
            hasaccess: process.env.REACT_APP_BASE_VALID_REPORTLINK_ACCESS
        })
    })

    function addGtext(lvInfo, hinweisData, potentialData,
                      risikoData) {
        let modifiedData = {}
        modifiedData.hinweisData = modifyForGtext(hinweisData, lvInfo)
        modifiedData.potentialData = modifyForGtext(potentialData, lvInfo)
        modifiedData.risikoData = modifyForGtext(risikoData, lvInfo)
        return modifiedData
    }

    function modifyForGtext(arrayData, lvInfo) {
        let ozData = lvInfo.data.OZ
        arrayData?.forEach((item) => {
            if (!(item.menge)) {
                item.menge = "NaN"
            }else{
                item.menge=Number(item.menge).toString().replace(".",",")
            }
            let ind = ozData.filter(obj => obj.row_id === item.rowId)
            ind = ind[0]
            if (!(ind.unit)) {
                item.unit = "NaN"
            } else {
                item.unit = ind.unit
            }
            let firstPart = ""
            let secondPart = ""
            if (ind.hinweis) {
                firstPart = ind.hinweis
                if (Array.isArray(firstPart)) {
                    firstPart = firstPart[0]
                }
                if (firstPart.toLowerCase() === "nan") {
                    firstPart = ""
                }
            }
            if (ind.long_text) {
                secondPart = ind.long_text
                if (Array.isArray(secondPart)) {
                    secondPart = secondPart[0]
                }
                if (secondPart.toLowerCase() === "nan") {
                    secondPart = ""
                }
            }
            if (firstPart + secondPart === "") {
                item.googleText = "NaN"
            } else {
                item.googleText = firstPart + secondPart
            }
        })
        return arrayData
    }

}

/**
 * Function to download the respective PDF Report
 * @param link
 * @returns {Promise<void>}
 */
export async function downloadPDFReport(link) {
    let returnvalue = await openpdfreport(link)
    if (returnvalue.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
        getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`)
    }
    if (returnvalue.signed_url !== "Pdf is generating") {
        location.href = returnvalue.signed_url
    } else {
        alert("Pdf is generating")
    }

}

// get project data for app
export async function getprojectandmetadata(apiBody){
    let res = await fetch(process.env.REACT_APP_BACKEND_API_URI + 'mobileappbackend/get_onemetaandproject', {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(apiBody)
            })
                .then((response) => response.json())
                .catch((error) => {
                    console.error('Error:', error);
                });
    return res
}
